/** Triggers a browser download of in-memory text as a file. */
export function downloadTextFile(
  filename: string,
  contents: string,
  mimeType = "text/csv;charset=utf-8",
): void {
  const url = URL.createObjectURL(new Blob([contents], { type: mimeType }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked on a later task: Safari and Firefox read the blob asynchronously
  // after the synthetic click, and revoking in the same tick aborts the save.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
